import 'initial-js';
import 'corejs-typeahead';
import Vue from 'vue';
import UINavbar from '@/scripts/legacy-ui-library/ui-navbar';
import BrowserDetector from '@/scripts/helpers/browser-detector';
import viddsee from '@/scripts/viddsee';
import loginController from '@/scripts/libs/login/controller';
import _ from 'underscore';
import fixNavAnchorOffset from '@/scripts/libs/patches/fixNavAnchorOffset';
import MissionModalContent from '@/scripts/Components/Organisms/Profile/ProfilePointsSection/MissionsListModalContent.ts.vue';
import DailyWelcomeContent from '@/scripts/Components/Organisms/Global/DailyWelcomeContent.ts.vue';
import { searchApi } from '@/scripts/webcall/v3/search';
import { meApi } from '@/scripts/webcall/v3/me';
import { PointSystemStore } from '@/scripts/store/modules/pointSystem';
import { infoApi } from '@/scripts/webcall/v3/info';

const _bindUIActions = function _bindUIActions() {
  $('.form-locale-selector-dropdown').on('change', function changeLocale() {
    const $form = $(this.form);

    ga(() => {
      const trackers = ga.getAll();
      const tracker = trackers.length > 0 ? trackers[0] : null;
      const currentLocale = tracker ? tracker.get('dimension2') : 'undefined';
      const newLocale = this.options[this.selectedIndex].value;
      const gaEvent = $form.hasClass('form-locale-selector--mobile')
        ? 'language-change-mobile'
        : 'language-change-desktop';
      const gaLabel = currentLocale + ' -> ' + newLocale;

      ga('send', 'event', 'localization', gaEvent, gaLabel);
    });

    this.form.submit();
  });

  $('.nav__sign-in').on('click', function openRegisterModal(e) {
    e.preventDefault();
    const $this = $(this);
    let gaAction = 'sign-up';
    if ($this.data('ga-action')) {
      gaAction = $this.data('ga-action');
    }
    if ($this.data('ga-title')) {
      ga('send', 'event', 'onboarding', gaAction, $this.data('ga-title'));
    } else {
      ga('send', 'event', 'onboarding', gaAction);
    }
    viddsee.ui.modal.register.open({
      loginReason: I18n.t('javascript.login-reason.from-navbar'),
    });
  });

  $('.nav__mission').on('click', async(e) => {
    e.preventDefault();
    const user = !!(await loginController.getUser());
    if (user === false) {
      viddsee.ui.modal.register.open({
        loginReason: I18n.t('javascript.login-reason.from-navbar'),
      });
    } else {
      const MissionModal = Vue.extend(MissionModalContent);
      const modalContent = new MissionModal({
        propsData: {
          closeModal: closeMissionModal,
          showCloseBtn: true,
        },
      }).$mount();
      const $this = $('#modal-missions');
      const missionContent = document.getElementById('missions-content');
      if (missionContent.children) {
        missionContent.replaceChildren(modalContent.$el);
      } else {
        missionContent.append(modalContent.$el);
      }
      $this.modal('show');
    }
  });

  $('#nav-wrapper').on('click', '.nav__btn--avatar', (e) => {
    e.preventDefault();
    $(e.currentTarget).trigger('vs.ui.navbar.profile.toggle');
  });

  $('.search__btn').on('click', (e) => {
    const $searchBars = $('.search');
    const $button = $(e.currentTarget);
    const $inputWrapper = $button.parent();

    const searchTerm = $inputWrapper
      .find('.search__input')
      .val()
      .trim()
    ;
    const isActive = $searchBars.hasClass('search--expanded');

    if (searchTerm && isActive) return;

    e.preventDefault();
    $button.trigger('vs.ui.navbar.search.toggle');
    if (!isActive) { // was not active and toggle is triggered
      [...$searchBars].forEach((searchBar) => {
        if (searchBar.offsetWidth) {
          const input = searchBar.querySelector('.search__input');
          if (input) input.focus();
        }
      });
    }
  });

  $('input.typeahead').on('typeahead:selected', (e) => {
    $(e.target)
      .parents('form')
      .submit()
    ;
  });

  $('.nav__btn--open_app').on('click', function openApp(e) {
    const $this = $(this);

    ga('send', 'event', 'deeplink', 'player-navbar');

    if (BrowserDetector.os() === 'AndroidOS') {
      window.open($this.data('href-android'));
      return false;
    } else if (BrowserDetector.os() === 'iOS') {
      window.open($this.data('href-ios'));
      return false;
    } else {
      window.open($this.attr('href'));
      return false;
    }
  });
};

const _typeaheadInit = function _typeaheadInit() {
  $('#scrollable-dropdown-menu .typeahead').typeahead(
    {
      hint: false,
      minLength: 1,
    },
    {
      display: 'value',
      async: true,
      source: async(query, syncresults, asyncResult) => {
        try {
          const data = await searchApi.getContentSuggestion(undefined, {
            search_string: query,
            include_details: true,
          });
          const tempData=[];
          data.data.films.forEach((film) => { tempData.push({ value: film.title, link: film.details.actionUrl }); });
          data.data.collections.forEach((film) => { tempData.push({ value: film.title, link: film.details.actionUrl }); });
          data.data.collaborators.forEach((film) => { tempData.push({ value: film.title, link: film.details.actionUrl }); });
          asyncResult(tempData);
        } catch (e) {
          asyncResult([]);
        }
      },
      templates: {
        suggestion(data) {
          return '<p style="margin :0"> <a style="border: none; box-shadow: none" href="'+data.link+'"><span style="display: block;">'+data.value+'</span></a></p>';
        },
      },
    },
  );
};

function _initDownloadAppLinks() {
  const $btnOpenInApp = $('.nav__btn--open_app');
  $btnOpenInApp
    .data('href-android', 'https://play.google.com/store/apps/details?id=com.viddsee')
    .data('href-ios', 'https://itunes.apple.com/app/viddsee-watch-asian-movies/id930821146');
}

export async function initMissions(refetch = false) {
  const $el = $('#modal-missions');
  if ($el.length <= 0) { return; }
  $el.modal({
    show: false,
  });
  await meApi.pointSystemApi.listMissions(undefined, { perPage: 999 }).then((data) => {
    const readyToClaimMissions = data.data.items.filter((item) => item.isAchieved && !item.isClaimed).length;
    PointSystemStore.commit('updateMissionsCount', readyToClaimMissions);
    if (readyToClaimMissions) {
      $('.nav__missions-number').removeClass('hidden');
      if ($('.nav__missions-number').children().length > 0) {
        $('.nav__missions-number').empty()
          .append(`<p>${readyToClaimMissions}</p>`);
      } else {
        $('.nav__missions-number').append(`<p>${readyToClaimMissions}</p>`);
      }
    } else {
      if ($('.nav__missions-number').hasClass('hidden')) return;
      $('.nav__missions-number').addClass('hidden');
      $('.nav__missions-number').children()
        .remove();
    }
  });
  if (refetch) {
    loginController.getUser(true).then((data) => {
      PointSystemStore.commit('updatePoints', data.points);
    });
  }
}

function _initWelcomeModal() {
  const $el = $('#modal-welcome');
  if ($el.length <= 0) { return; }
  $el.modal({ backdrop: 'static', keyboard: false, show: false });
}

async function closeWelcomeModal() {
  // hide first, regardless of outcome
  $('#modal-welcome').modal('hide');
  try {
    await meApi.pointSystemApi.AttemptMission(undefined, undefined, { signalType: 'DAILY_LOGIN', details: {} }).then(() => {
      initMissions();
    });
  } catch (error) {
    // console.error(error);
  }
}

function closeMissionModal() {
  $('#modal-missions').modal('hide');
}
async function _getWelcomeInfo() {
  const data = await infoApi.welcomeInfo();
  return data.data;
}

const Navbar = {
  async init() {
    fixNavAnchorOffset(document.querySelector('.nav-wrapper'));
    let welcomeInfoData = null; // because {} is always truthy

    UINavbar.registerEventBindings();
    _initDownloadAppLinks();
    _bindUIActions();
    _typeaheadInit();
    initMissions();
    _initWelcomeModal();
    _getWelcomeInfo().then((data) => {
      welcomeInfoData = data;
    });

    // Update navbar login information
    loginController.getUser()
      .then((user) => {
        if (!user) return;

        PointSystemStore.commit('updatePoints', user.points);
        const profileImageMarkup = `
      <a href="#" class="btn--circle nav__btn--avatar">
        <img
          class="avatar ${user.profile.profileImageUrl ? '' : 'default-profile'}"
          ${
  user.profile.profileImageUrl
    ? `src="${user.profile.profileImageUrl}"`
    : `data-name="${user.profile.firstName}"`
}
        >
      </a>`;

        $('.nav__sign-in').replaceWith(profileImageMarkup);

        if (!user.profile.hasDoneDailyLogin && welcomeInfoData) {
          const WelcomeModal = Vue.extend(DailyWelcomeContent);
          const modalContent = new WelcomeModal({
            propsData: {
              user,
              closeModal: closeWelcomeModal,
              welcomeInfo: welcomeInfoData,
            },
          }).$mount();
          const $this = $('#modal-welcome');
          const welcomeContent = document.getElementById('welcome-content');
          if (welcomeContent.children) {
            welcomeContent.replaceChildren(modalContent.$el);
          } else {
            welcomeContent.append(modalContent.$el);
          }
          $this.modal({ backdrop: 'static', keyboard: false }, 'show');
        }

        if ($('.tpl-navbar-profile-dropdown')[0]) {
          const profileDropdownTemplate = _.template($('.tpl-navbar-profile-dropdown').html());
          $('.nav__btn--avatar')
            .parent()
            .append(profileDropdownTemplate)
          ;
        }
        if ($('.tpl-navbar-profile-dropdown-mobile')[0]) {
          const profileDropdownMobileTemplate = _.template($('.tpl-navbar-profile-dropdown-mobile').html());
          $('nav.nav').after(profileDropdownMobileTemplate);
        }

        $('.js-logout').on('click', (e) => {
          e.preventDefault();
          loginController.logout();
        });

        try {
          $('img.default-profile').initial();
        } catch (error) {
          // Initial will throw error when it cannot generate a profile image for a user.
          // I will ignore this error for now.
          // Profile Initial implementation should be replaced
          // See: https://github.com/viddsee/viddsee-api/issues/1945
        }
      });
  },
};

export default Navbar;
